import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { CatalogService } from '../../../../providers/catalogs/catalogs.service';
import { ClubService } from '../../../../providers/club/club.service';
import { UtilitiesService } from '../../../../providers/utilities.provider';
import { Clubs, Jobs } from '../../../../public/signup/club/club.model';

@Component({
    selector: 'ngx-input-clubstaff-role-dialog',
    templateUrl: 'input-clubstaff-role-dialog.component.html',
    styleUrls: ['input-clubstaff-role-dialog.component.scss'],
})
export class InputClubStaffRoleDialogComponent {

    @Input() country: any;
    @Input() state: any;
    @Input() element: any;
    @Input() jobsTitle: Jobs[];

    private subscriptions$ = new Subscription();
    public form: FormGroup;
    public clubs$: Promise<Clubs[]>;
    public filteredClubsOptions$: Promise<Clubs[]>;
    public sports = [];

    constructor(
      protected ref: NbDialogRef<InputClubStaffRoleDialogComponent>, 
      private nbDialog: NbDialogService, 
      private formBuilder: FormBuilder,
      private catalogService: CatalogService,
      private clubService: ClubService) {
        this.form = this.formBuilder.group({
            sport: [null, [Validators.required]],
            club: [null, [Validators.required]],
            jobTitle: [null, [Validators.required]],
        });
    }

    ngOnInit(): void {

      this.form.get('club').disable();
      this.form.get('jobTitle').disable();

      this.catalogService.findSports().then(res => {
        this.sports = res;
      });

      this.subscriptions$.add(this.form.get('sport').valueChanges
      .subscribe((value:any) => {
        if(!value) return
        
        this.form.get('club').reset();
        this.form.get('club').enable();
        this.form.get('jobTitle').reset();
        this.form.get('jobTitle').enable();

        if (value != undefined) {
          this.findClub(value.id, this.country, this.state);
        }
      }));

      this.subscriptions$.add(this.form.get('club').valueChanges
      .subscribe(value => {
          if (value != undefined) {
              typeof value === 'object' ? this.form.get('club').setErrors(null) : this.form.get('club').setErrors({ error: true });
              value = typeof value === 'string' ? value : value.value
              this.filteredClubsOptions$ = value ? this.clubs$.then((response) => { return response.filter(option => option.name.toLowerCase().includes(value.toLowerCase())); }) : this.clubs$;
          }
      }));
    }

    findClub(sport: number, idCountry, stateKey) {
      this.clubs$ = this.clubService.findClubs(sport, idCountry, stateKey);
      this.filteredClubsOptions$ = this.clubs$;
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }

    ngAfterViewInit(): void {
        //  document.getElementById("yesButton").focus();
    }

    displayFnClub(club: any): string {
        return club && club.name ? club.name : '';
    }

    dismiss(value: boolean) {
        if (value) {
            UtilitiesService.showConfirmDialog(this.nbDialog, "Add Role", null, "Do you want to add the " + this.element.name + " role?", "Yes", "Cancel").then(res => {
                if (res) {
                    this.ref.close({ club: this.form.value.club, jobTitle: this.form.value.jobTitle });
                }
            })
        } else {
            this.ref.close(value);
        }
    }
}
